import {
  getUrlRootPath,
  trimBasenameAndNetworkFromUrlPath,
  trimLeadingAndTrailingSlash,
} from '@ms/yammer-libs-url-path-support';

const eventPaths = ['events', 'broadcasts'];

type IsEventsPage = (urlPath: string) => boolean;
export const isEventsPage: IsEventsPage = (urlPath) => {
  const urlRootPath = getUrlRootPath(urlPath);

  return eventPaths.includes(urlRootPath);
};

type GetEventBroadcastDataFromPath = (
  urlPath: string
) => { readonly version: 'v1' | 'v2'; readonly id: string } | undefined;
export const getEventBroadcastDataFromPath: GetEventBroadcastDataFromPath = (urlPath) => {
  const urlPathWithoutBasename = trimBasenameAndNetworkFromUrlPath(urlPath);
  const urlPathParts = trimLeadingAndTrailingSlash(urlPathWithoutBasename).split('/');

  if (!eventPaths.includes(urlPathParts[0]) || urlPathParts[1] === 'new') {
    return;
  }

  const version = urlPathParts[0] === 'broadcasts' ? 'v2' : 'v1';
  const id: string | undefined = urlPathParts[1];

  return id ? { version, id } : undefined;
};
